/**
 * Normalizacija URL-jev za canonical link in JSON-LD bloke.
 *
 * Uporablja se tako pri generiranju canonical/og:url/mainEntityOfPage v
 * route head() kot v testih (src/test/article-jsonld-schema.test.ts), da se
 * izognemo lažnim neujemanjem zaradi presledkov, trailing slasha ali
 * različno kapitalizirane domene.
 *
 * Pravila:
 *  - trim presledkov
 *  - host (in protokol) v lowercase
 *  - odstrani trailing slash, RAZEN za root ("https://kupish.si/")
 *  - pot, query in fragment ostanejo case-sensitive (poti so občutljive na velikost)
 */

export const SITE_ORIGIN = "https://kupish.si";

export function normalizeUrl(input: string): string {
  if (!input) return input;
  const trimmed = input.trim();
  try {
    const u = new URL(trimmed);
    u.protocol = u.protocol.toLowerCase();
    u.hostname = u.hostname.toLowerCase();
    let pathname = u.pathname || "/";
    if (pathname.length > 1 && pathname.endsWith("/")) {
      pathname = pathname.replace(/\/+$/, "");
    }
    u.pathname = pathname;
    return u.toString();
  } catch {
    // Relativni vnosi: trim + odstrani trailing slash (razen "/")
    let p = trimmed;
    if (p.length > 1 && p.endsWith("/")) p = p.replace(/\/+$/, "");
    return p;
  }
}

/** Zgradi absoluten canonical URL za dano pot (npr. "/clanek/foo"). */
export function buildCanonical(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return normalizeUrl(`${SITE_ORIGIN}${p}`);
}

/** Primerjava dveh URL-jev po normalizirani obliki. */
export function urlsEqual(a: string, b: string): boolean {
  return normalizeUrl(a) === normalizeUrl(b);
}
